<template>
  <div class="edit-button">
    <button @click="$emit('update')" class="btn-save pl-3 pr-3 pb-3 pt-5">
      {{saveText}}
    </button>
  </div>
</template>
<script>
export default {
  name: 'UpdateButton',
  computed:{
    saveText(){
      return this.$t('save-button')
    }
  }
};
</script>
<style scoped>
  .btn-save{
    background: #15236d;
    border-radius: 10px 10px 0 0;
    color:white;
    width:140px;
    line-height:10px;
    /* padding: 10px 10px 10px 20px; */
  }
  .btn-save:hover{
    cursor: pointer;
    background: green;
    font-weight:bold;

  }
  .edit-button {
    display: flex;
    justify-content: center;
    position: fixed;
    top: 214px;
    /* top: calc(50% - 57px); */
    left: calc(100% - 94px);
    transform: rotate(-90deg);
  }
</style>
